import {
    Flex,
    Heading,
    Image,
    SimpleGrid,
    Text,
    Tooltip,
} from '@chakra-ui/react'
import KalviumSdk from '@kalvi-education/kalvium-sdk'
import { useQuery } from '@tanstack/react-query'

import { defaultBorder } from '../../../../chakraTheme'
import { DIRECT, UNIVERSITY } from '../enums/clientType'

const univLogoBorder = '0.75px solid #6b6b6b'
const UNIVERSITIES = [
    {
        logoUrl:
            'https://kalvi-file-storage.s3.ap-southeast-1.amazonaws.com/University-Logos/LPU-Jalandhar.png',
        name: 'Lovely Professional University, Jalandhar',
    },
    {
        logoUrl:
            'https://kalvi-file-storage.s3.ap-southeast-1.amazonaws.com/University-Logos/Manipal-University-Jaipur.png',
        name: 'Manipal University, Jaipur',
    },
    {
        logoUrl:
            'https://kalvi-file-storage.s3.ap-southeast-1.amazonaws.com/University-Logos/RV-University-Bengaluru.png',
        name: 'RV University, Bengaluru',
    },
    {
        logoUrl:
            'https://kalvi-file-storage.s3.ap-southeast-1.amazonaws.com/University-Logos/JECRC-University-Jaipur.png',
        name: 'JECRC University, Jaipur',
    },
    {
        logoUrl:
            'https://kalvi-file-storage.s3.ap-southeast-1.amazonaws.com/University-Logos/MIT-ADT-University-Pune.png',
        name: 'MIT ADT University, Pune',
    },
    {
        logoUrl:
            'https://kalvi-file-storage.s3.ap-southeast-1.amazonaws.com/University-Logos/VISTAS(Vels)-Chennai.png',
        name: 'Vels Institute of Science, Technology & Advanced Studies, Chennai',
    },
    {
        logoUrl:
            'https://kalvi-file-storage.s3.ap-southeast-1.amazonaws.com/University-Logos/Chitkara-University-baddi.png',
        name: 'Chitkara University, Baddi',
    },
    {
        logoUrl:
            'https://kalvi-file-storage.s3.ap-southeast-1.amazonaws.com/University-Logos/The-Apollo-University-Chittoor.png',
        name: 'The Apollo University, Chittoor',
    },
]

const ProgramInfo = ({ clientSlug }) => {
    const clientType = clientSlug === DIRECT ? DIRECT : UNIVERSITY
    const isDirectApplicant = clientType === DIRECT

    const { data: client } = useQuery({
        queryKey: ['client', clientSlug],
        queryFn: async () => {
            return KalviumSdk.services.admission.fetchClient(clientSlug)
        },
        retry: 2,
        staleTime: 60000,
    })

    return (
        <Flex
            maxW={{ lg: '588px' }}
            minW={{ lg: '588px' }}
            h={{ lg: 'full' }}
            borderRight={{ lg: defaultBorder }}
            w={{ lg: '588px' }}
            alignItems={{ base: 'center', lg: 'flex-start' }}
            justifyContent="center"
            px={{ base: 4, md: 16 }}
            py={'72px'}
            flexDirection="column"
            borderBottom={{ base: defaultBorder, lg: 'none' }}
        >
            {!isDirectApplicant && (
                <>
                    <Image
                        src={client.logo_url}
                        height={150}
                        width={150}
                        border={univLogoBorder}
                        backgroundColor={'#FFF'}
                    />
                    <Heading color="scorpion2" fontSize="md" mt={8} mb={4}>
                        {client.university_name}
                    </Heading>
                </>
            )}
            <Heading
                as="h3"
                fontSize="3xl"
                color="mineshaft"
                textAlign={{ base: 'center', lg: 'left' }}
            >
                Get Started with Your Kalvium Journey
            </Heading>
            {isDirectApplicant ? (
                <Text
                    mt={6}
                    color="mineshaft"
                    textAlign={{ base: 'center', lg: 'left' }}
                >
                    Register and Qualify the Kalvium National Entrance Test 24!
                    - <span style={{ fontWeight: '700' }}>KNET&apos;24</span> to
                    pursue the Work Integrated Kalvium program at any of the{' '}
                    <b>10+ leading universities</b> in India and abroad.
                </Text>
            ) : (
                <Text
                    mt={6}
                    color="mineshaft"
                    textAlign={{ base: 'center', lg: 'left' }}
                >
                    Register and Qualify the Kalvium National Entrance Test 24!
                    - <span style={{ fontWeight: '700' }}>KNET&apos;24</span> to
                    pursue the Kalvium program at{' '}
                    <b>
                        {client.university_name}, &nbsp;{client.campus}.
                    </b>
                </Text>
            )}
            {isDirectApplicant && (
                <>
                    <SimpleGrid
                        gap={4}
                        columns={{ base: 4, md: 8, lg: 4 }}
                        mt={12}
                    >
                        {UNIVERSITIES.map(university => (
                            <Tooltip
                                label={university.name}
                                variant={'retro'}
                                shouldWrapChildren
                                key={university.name}
                            >
                                <Image
                                    src={university.logoUrl}
                                    border={univLogoBorder}
                                    width={{
                                        base: '70px',
                                        md: '72px',
                                        lg: '103px',
                                    }}
                                    height={{
                                        base: '70px',
                                        md: '72px',
                                        lg: '103px',
                                    }}
                                />
                            </Tooltip>
                        ))}
                    </SimpleGrid>
                    <Text
                        color="athensgray3"
                        textAlign={'center'}
                        fontSize={'xs'}
                        mt={4}
                        w="full"
                    >
                        and many more...
                    </Text>
                </>
            )}
        </Flex>
    )
}

export default ProgramInfo
